module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#int"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ints1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#s1"
    }
  }, [_vm._v("Constructing the “Historical Paul”")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ints2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#s2"
    }
  }, [_vm._v("Constructing the Canonical Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ints3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#s3"
    }
  }, [_vm._v("The Plan of This Work")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/part1#pt001"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" 1: P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RELIMINARY")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("CAFFOLDING")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Assessing the Sources")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s1"
    }
  }, [_vm._v("Traditions about Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s2"
    }
  }, [_vm._v("Apocryphal Compositions")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s3"
    }
  }, [_vm._v("Apocalypses")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s4"
    }
  }, [_vm._v("Acts")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s5"
    }
  }, [_vm._v("Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch1s6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s6"
    }
  }, [_vm._v("Canonical Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s7"
    }
  }, [_vm._v("The Acts of the Apostles")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s8"
    }
  }, [_vm._v("Non-Pauline Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch1s9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001#s9"
    }
  }, [_vm._v("Canonical Pauline Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#ch002"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Paul’s Life and Apostolic Ministry")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s1"
    }
  }, [_vm._v("Evaluating the Sources")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s2"
    }
  }, [_vm._v("Chronology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s3"
    }
  }, [_vm._v("Apostolic Style")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s4"
    }
  }, [_vm._v("Theology")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s5"
    }
  }, [_vm._v("Paul’s Early Life")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s6"
    }
  }, [_vm._v("Persecutor")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s7"
    }
  }, [_vm._v("Encounter with the Risen Lord Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s8"
    }
  }, [_vm._v("Patterns of Paul’s Ministry")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch2s9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002#s9"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#ch003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Pauline Correspondence")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Epistolary Context")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Common Characteristics")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epistolary Structure")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elements of Composition")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch3s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clusters of Letters and an Adequate Model of Authorship")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thessalonian Cluster")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Galatians/Romans Cluster")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Corinthians Cluster")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colossians/Ephesians Cluster")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letters to Paul’s Delegates Cluster")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philippians and Philemon")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch3s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter003#s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A More Adequate Model of Authorship")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-004"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#ch004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Paul’s Place in Early Christianity")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul as Founder of Christianity")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evidence of Paul’s Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Evidence from Other Early Christian Literature")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Opponents")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First and Second Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First and Second Corinthians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_vii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Galatians and Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philippians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ephesians and Colossians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Letters to Delegates")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch4s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Summary of Evidence")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Pauline School")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch4s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004#s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/part2#pt002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" 2: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATERIALS")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-005"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#ch005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("What Kind of Jew Is Paul?")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Complexities of the Question")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Jewish Identity")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Place in the Jewish World")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch5s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Prophetic Jew")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-006"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#ch006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Paul and Scripture")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Scripture-Defined World")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Scripture as Implied Premise")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch6s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-007"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#ch007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Paul and Greco-Roman Culture")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preliminary Questions")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch7s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Postcolonial Interpretation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch7s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Term “Greco-Roman”")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul and Paideia")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rhetoric")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philosophy")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Religion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch7s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007#s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc-pt",
    attrs: {
      "id": "pt-003"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/part3#pt003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ART")]), _vm._v(" 3: T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEMENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-008"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#ch008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("The Claims of Experience")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Objections to the Experiential")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Resurrection Experience")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Resurrection of Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Resurrection as Affecting Others")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Participation in the Resurrection")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jesus Is Lord / The Power of the Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Texture of Experience in the Letters")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Romans")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Corinthians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Corinthians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Galatians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ephesians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philippians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Colossians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("First Timothy")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Second Timothy")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Titus")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch8s20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Philemon")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch8s21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008#s21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-009"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#ch009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "space1"
  }, [_vm._v("Convictions, Myths, Symbols, and Metaphors")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch9s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Convictions")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch9s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Myth and Symbol")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch9s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Myth")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch9s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Symbol")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch9s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metaphor")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch9s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metaphors for Salvation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch9s7"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metaphors for the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch9s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009#s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-010"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#ch010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Paul’s Voice—Philemon")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch10s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Connections")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch10s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Construals")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch10s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul’s Voice in Philemon")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch10s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Philemon Together with Colossians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch10s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Philemon Together with Ephesians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch10s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter010#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc",
    attrs: {
      "id": "ch-011"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#ch011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "space"
  }, [_vm._v("Paul, Oppressor or Liberator?")])])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch11s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marcion and Irenaeus")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch11s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Apostle of the Theologians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch11s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Case against Paul")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch11s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Cultured Despisers")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch11s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jewish Detractors")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch11s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Feminist and Womanist Critics")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch11s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Oppressed Objectors")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch11s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reading Paul Responsibly")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch11s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Paul as Liberator")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch11s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("God’s Presence and Power in Creation")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch11s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Transforming Power of the Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch11s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Church as God’s Instrument")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch11s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tension between the Ideal and the Real")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "ch11s14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter011#s14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "bib"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "idx-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index001#idx001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "idx-002"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index002#idx002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Subjects")])]), _vm._v(" "), _c('p', {
    staticClass: "Tocc",
    attrs: {
      "id": "idx-003"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index003#idx003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index of Scripture and Other Ancient Sources")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-218d4410","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0